import {Injectable} from '@angular/core';
import {merge} from 'rxjs';
import {BehaviorSubject} from 'rxjs';
import {Observable} from 'rxjs/internal/Observable';
import {filter} from 'rxjs/operators';
import {AlertService} from '../../viewer/services/alert.service';
import {Notification} from '../interfaces/notification-base.interface';
import {AlertsNotificationsService} from './alerts-notifications.service';
import {DocumentRequestNotificationsService} from './document-request-notification.service';
import { WorkflowNotificationService } from './workflow-notification.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationMenuService {
  public unSeenCountSubject = new BehaviorSubject<number>(0);

  constructor(
    private alertService: AlertService,
    private alertsNotificationService: AlertsNotificationsService,
    private documentRequestNotificationService: DocumentRequestNotificationsService,
    private workflowNotificationService:WorkflowNotificationService
  ) {
    this.unseenNotificationsCount();
  }

  private _allNotifications$: Observable<Notification>;

  get allNotifications$(): Observable<Notification> {
    return this._allNotifications$;
  }

  set allNotifications$(value: Observable<Notification>) {
    this._allNotifications$ = value;
  }

  private _unSeenCount = 0;

  get unSeenCount(): number {
    return this._unSeenCount;
  }

  set unSeenCount(value: number) {
    this._unSeenCount = value;
    this.unSeenCountSubject.next(this.unSeenCount);
  }

  resetCount() {
    this.unSeenCount = 0;
  }

  unseenNotificationsCount() {
    this.initAllNotificationsStream();
    this.allNotifications$.subscribe(() => {
      this._unSeenCount = this._unSeenCount + 1;
      this.unSeenCountSubject.next(this._unSeenCount);
    });
  }

  initAllNotificationsStream() {
    const notificationServices: Observable<Notification>[] = [
      this.alertsNotificationService.initNotifications(),
      this.documentRequestNotificationService.initNotifications(),
      this.alertsNotificationService.notifications$.asObservable(),
      this.documentRequestNotificationService.notifications$.asObservable(),
      this.workflowNotificationService.notifications$.asObservable(),
      this.workflowNotificationService.initNotifications()
    
    ];
    this.allNotifications$ = merge(...notificationServices);
  }
}

